$(function () {
    if( $('.fontsize_row').length == 0 ) return;
    
    const winW = $(window).width();
    const plus = $('.plus');
    const minus = $('.minus');
    const ori = $('.ori');
    const html = $('html');
    const fontSize = parseInt(html.css('font-size'));
    let num = 0;
    plus.click(function () {
        if (num < 3) {
            num++;
            minus.attr('disabled', false);
        } else {
            num++;
            $(this).attr('disabled', true);
        }
        html.css('font-size', (fontSize + num) / winW * 100 + 'vw');
    });
    minus.click(function () {
        if (num > -3) {
            num--;
            plus.attr('disabled', false);
        } else {
            num--;
            $(this).attr('disabled', true);
        }
        html.css('font-size', (fontSize + num) / winW * 100 + 'vw');
    });
    ori.click(function () {
        num = 0;
        minus.attr('disabled', false);
        plus.attr('disabled', false);
        html.css('font-size', fontSize / winW * 100 + 'vw');
    });
});